/**
 *
 * Asynchronously loads the component for RequireAuth
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
